import { twMerge } from 'tailwind-merge';
import { Text } from '../../Text/Text';

interface IProps {
  message: string;
  className?: string;
}

export const ProhibitionWarning = ({ message, className }: IProps) => (
  <div
    className={twMerge('text-error-shade bg-error-tint rounded-lg p-2', className)}
    data-testid="RegulationProhibitionWarning"
  >
    <Text variant="sm" className="mb-0 font-semibold">
      {message}
    </Text>
  </div>
);
